<template>
    <div key="contact_details">
        <!--Agency Contact Details-->
        <div class="relative border border-orange-100 shadow-sm bg-orange-50 text-gray-600 rounded-md flex flex-col flex-1">
            <div class="flex justify-between items-center">
                <h1 class="font-bold text-sm p-2 leading-none">Agency Details</h1>
            </div>
            <!--Administrator Full name-->
            <div class="my-1 px-2 py-1 flex">
                <div class="text-indigo-700">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </div>
                <div class="px-2 leading-tight text-sm text-orange-700">
                    {{ mutableTask.ticket.assigned_to.full_name }}
                </div>
            </div>
            <!--Agency Email-->
            <div class="my-1 px-2 py-1 flex">
                <div class="text-indigo-700">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                </div>
                <div class="px-2 leading-tight text-sm text-orange-700">
                    {{ mutableTask.ticket.assigned_to.email }}
                </div>
            </div>
            <!--Agency Phone-->
            <div class="my-1 px-2 py-1 flex">
                <div class="text-indigo-700">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                    </svg>
                </div>
                <div class="px-2 leading-tight text-sm text-orange-700">
                    {{ mutableTask.ticket.assigned_to.phone }}
                </div>
            </div>
            <!--Relative Assigned Time-->
            <div class="my-1 px-2 py-1 flex">
                <div class="text-indigo-700">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </div>
                <div class="px-2 leading-tight text-sm text-orange-700">
                    Assigned {{ mutableTask.relative_assigned_time }}
                </div>
            </div>
        </div>

        <!--Landlord Contact Details-->
        <div class="my-2 border border-orange-100 shadow-sm bg-orange-50 text-gray-600 rounded-md flex flex-col flex-1">
            <div class="flex justify-between items-center">
                <h1 class="font-bold text-sm p-2 leading-none">Landlord Details</h1>
            </div>
            <!-- Landlord Full Name -->
            <div class="my-1 px-2 py-1 flex">
                <div class="text-indigo-700">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </div>
                <div class="px-2 leading-tight text-sm text-orange-700">
                    {{ mutableTask.ticket.primary_landlord.full_name }}
                </div>
            </div>
            <div v-if="mutableTask.show_landlord_details && mutableTask.ticket.primary_landlord">
                <!-- Landlord Email -->
                <div v-if="mutableTask.ticket.primary_landlord.email" class="my-1 px-2 py-1 flex">
                    <div class="text-indigo-700">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                        </svg>
                    </div>
                    <div class="px-2 leading-tight text-sm text-orange-700">
                        {{ mutableTask.ticket.primary_landlord.email }}
                    </div>
                </div>
                <!-- Landlord Mobile -->
                <div v-if="mutableTask.ticket.primary_landlord.mobile" class="my-1 px-2 py-1 flex">
                    <div class="text-indigo-700">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                        </svg>
                    </div>
                    <div class="px-2 leading-tight text-sm text-orange-700">
                        {{ mutableTask.ticket.primary_landlord.mobile }}
                    </div>
                </div>
            </div>
        </div>

        <!--Tenant Contact Details-->
        <div class="my-2 border border-orange-100 shadow-sm bg-orange-50 text-gray-600 rounded-md flex flex-col flex-1">
            <div class="flex justify-between items-center">
                <h1 class="font-bold text-sm p-2 leading-none">Tenant Details</h1>
                <div v-if="!viewOnly && mutableTask.qa_required == true && mutableTask.qa_status.toLowerCase() !== 'quality assurance completed'"
                     class="font-bold text-sm bg-white flex items-start cursor-pointer rounded-md mr-2 shadow-sm px-2 py-0.5 hover:text-orange-600"
                     @click="$emit('send-qa-code', 'tenant')">
                    <!--Badge icon-->
                    <svg class="w-4 h-4 transform rotate-45" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                    </svg>
                    <span>Request QA</span>
                </div>
            </div>
            <!-- Tenant Full Name -->
            <div class="my-1 px-2 py-1 flex">
                <div class="text-indigo-700">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </div>
                <div class="px-2 leading-tight text-sm text-orange-700">
                    {{ mutableTask.ticket.primary_tenant.full_name }}
                </div>
            </div>
            <div v-if="mutableTask.show_tenant_details && mutableTask.ticket.primary_tenant">
                <!-- Tenant Email -->
                <div v-if="mutableTask.ticket.primary_tenant.email" class="my-1 px-2 py-1 flex">
                    <div class="text-indigo-700">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                        </svg>
                    </div>
                    <div class="px-2 leading-tight text-sm text-orange-700">
                        {{ mutableTask.ticket.primary_tenant.email }}
                    </div>
                </div>
                <!-- Tenant Mobile -->
                <div v-if="mutableTask.ticket.primary_tenant.mobile" class="my-1 px-2 py-1 flex">
                    <div class="text-indigo-700">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                        </svg>
                    </div>
                    <div class="px-2 leading-tight text-sm text-orange-700">
                        {{ mutableTask.ticket.primary_tenant.mobile }}
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "TaskCardContactDetails",

    props: {
        task: {
            required: true,
            type: Object,
        },
        viewOnly :{
            required: true,
            type: Boolean,
            description: "The task card is view only when an agency team views it"
        }
    },

    data () {
        return {
            mutableTask: this.task,
        };
    },

};
</script>

<style scoped>

</style>